import { CREATETIMELINE, DELETETIMELINE, GETTIMELINE, UPDATETIMELINE } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATETIMELINE:
            return {
                ...state,
                timelineSaveStatus: action.payload.success,
            }
        case GETTIMELINE:
                return {
                        ...state,
                        timelineList: action.payload.data,
                        }
        case UPDATETIMELINE:
                return {
                        ...state,
                        timelineUpdateStatus: action.payload.success,
                        }   

        case DELETETIMELINE:
                 return {
                     ...state,
                     timelineDeleteStatus: action.payload.success,
                        } 
                        default:
                            return state
                             }
                         }